<template>
  <van-sticky :offset-top="0">
    <van-nav-bar class="top-nav-bar" :border="false">
      <template #left>
        <slot name="left">
          <img src="@/assets/images/layout/default_avatar.png" alt="" class="avatar" @click="popup.user=true">
          <van-popup v-model="popup.user" get-container="body" position="left" class="user-popup">
            <div class="ent-head wh-flex-start">
              <img src="@/assets/images/layout/default_avatar.png" alt="" class="avatar">
              <div class="name">
                {{ $store.state.userInfo.User.username }} >
              </div>
            </div>
            <div class="content-box">
              <div class="menus">
                <van-cell v-for="i in userMenuOptions" :key="i.name" :border="false" is-link :to="i.route">
                  <template #title>
                    <img :src="i.icon" alt="" class="icon-img">
                    <span class="name">{{ i.name }}</span>
                  </template>
                </van-cell>
              </div>
              <div
                v-if="$store.state.menuState&&isOnlyProcess"
                class="wh-flex-center others-menus"
                @click="toProduct"
              >
                <img :src="require('@/assets/images/layout/loop.png')" alt="" class="icon-img">
                <span>切换到加工操作</span>
              </div>
              <div v-if="!$store.state.menuState&&isOnlyProcess" class="wh-flex-center others-menus" @click="toProduct">
                <img :src="require('@/assets/images/layout/loop.png')" alt="" class="icon-img">
                <span>切换到种植操作</span>
              </div>
            </div>
            <van-button type="danger" class="logout-btn" @click="logout">
              退出登录
            </van-button>
          </van-popup>
        </slot>
      </template>
      <template #title>
        <slot name="title">
          {{ title }}
        </slot>
      </template>
      <template #right>
        <slot name="right" />
      </template>
    </van-nav-bar>
  </van-sticky>
</template>

<script>
import { TOKEN_NAME } from '@/constant/config'
import api from '@/api'
import { checkPermission } from '@/utils/permission'

export default {
  name: 'HomeNavBar',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tabStatus: true, // true false
      popup: {
        user: false
      },
      userMenuOptions: [
        {
          icon: require('@/assets/images/layout/qyxx.png'),
          name: '企业信息',
          route: {
            name: 'EnterpriseSetting'
          }
        },
        {
          icon: require('@/assets/images/layout/yggl.png'),
          name: '员工管理',
          route: {
            name: 'Staff'
          }
        },
        {
          icon: require('@/assets/images/layout/nzkc.png'),
          name: '农资库存',
          route: {
            name: 'AgrList'
          }
        },
        {
          icon: require('@/assets/images/layout/ylkc.png'),
          name: '原料库存',
          route: {
            name: 'StockStore'
          }
        }
      ]
    }
  },
  computed: {
    isOnlyProcess() {
      if (this.$store.state.companyInfo.companyType && this.$store.state.companyInfo.companyType.length) {
        return this.$store.state.companyInfo.companyType.includes('加工业')
      } else {
        return false
      }
    }
  },
  methods: {
    toProduct() {
      if (this.$store.state.menuState) {
        this.$router.push({
          name: 'Process'
        })
      } else {
        if (checkPermission(['水产业', '养殖业', '种植业'])) {
          this.$router.push({
            name: 'MyPlot'
          })
        } else {
          this.$router.push({
            name: 'More'
          })
        }
      }
      this.$store.state.menuState = !this.$store.state.menuState
    },
    logout() {
      api.logout().then(() => {
        localStorage.removeItem(TOKEN_NAME)
        this.$toast('退出登录成功')
        this.$router.push({ name: 'Login' })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.avatar {
  display: block;
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 50%;
}
.user-popup {
  width: 80%;
  height: 100%;
  background: #F6F5F5;
  .ent-head {
    background: #fff;
    padding: 70px 16px 10px;
    .avatar {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      object-fit: cover;
      margin-right: 15px;
    }
    .name {
      font-size: 12px;
      font-weight: bold;
      color: #323332;
    }
  }
  .content-box {
    padding: 16px;
    .menus {
      overflow: hidden;
      background: #FFFFFF;
      border-radius: 10px;
    }
    .others-menus{
      padding-top: 30px;
      color: #20CAA0;
      font-size: 12px;
    }
    .icon-img {
      width: 16px;
      height: 16px;
      margin-right: 5px;
      object-fit: contain;
    }
    .icon-img, .name {
      vertical-align: middle;
    }
  }
  .logout-btn {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    display: block;
    margin: 0 auto;
    width: 180px;
  }
}
</style>
